
import './StandardInputField.css';

const StandardInputField = ({title, value, setTo, locked, width=300, searchCustomer, globalUpdate=null, complete=null}) => {
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            if(searchCustomer) searchCustomer();
        }
    };

    const globalUpdateCall = () => {
        if(globalUpdate) globalUpdate();
    };

    // Determine validation state class
    const getValidationClass = () => {
        if (complete === null) return '';
        if (complete === false) return 'incomplete';
        if (complete === true) return 'complete';
        return '';
    };

    // Determine indicator icon
    const getValidationIndicator = () => {
        if (complete === null) return null;
        if (complete === false) return <span className='validation-indicator error'>*</span>;
        if (complete === true) return <span className='validation-indicator success'>✓</span>;
        return null;
    };

    return(
        <div className='standard-input-field-container'>
            <div className='standard-input-field-label'>
                {title}:
                {getValidationIndicator()}
            </div>
            {!locked && (
                <input 
                    className={`standard-input-field-input ${getValidationClass()}`}
                    style={{width:`${width}px`}} 
                    onBlur={() => globalUpdateCall()}  
                    value={value} 
                    onChange={e => setTo(e.target.value)} 
                    onKeyDown={e => handleKeyDown(e)}
                />
            )}
            {locked && (
                <input 
                    className={`standard-input-field-input ${getValidationClass()}`}
                    disabled 
                    style={{width:`${width}px`}} 
                    value={value} 
                    onChange={e => setTo(e.target.value)}
                />
            )}
        </div>
    )
};

export default StandardInputField;